import cn from "classnames";
import { CustomToggleProps, TOGGLE_SIZE } from "./CustomToggle.types";
import styles from "./CustomToggle.module.scss";

export const CustomToggle = ({
  checked,
  onChange,
  disabled = false,
  className,
  label,
  size = TOGGLE_SIZE.M,
}: CustomToggleProps) => {
  // Handle click event
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  // Handle keyboard events for accessibility
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div className={cn(styles.toggleWrapper, className)} onClick={handleClick}>
      <div
        className={cn(styles.toggle, styles[size], {
          [styles.checked]: checked,
          [styles.disabled]: disabled,
        })}
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={handleKeyDown}
      >
        {/* Toggle track/background */}
        <div className={styles.track} />

        {/* Toggle thumb/slider */}
        <div className={styles.thumb} />
      </div>

      {/* Optional label */}
      {label && <span className={cn(styles.label, { [styles.disabled]: disabled })}>{label}</span>}
    </div>
  );
};
